import { createRouter, createWebHistory } from "vue-router";
import authService from '../services/authService';
import { getDefaultAppScreen } from '../views/Settings/customerConfigHelper';
import Default from "../views/dashboards/Default.vue";
import Sales from "../views/dashboards/Sales.vue";
import Overview from "../views/pages/profile/Overview.vue";
import Projectss from "../views/pages/profile/Projects.vue";
import Timeline from "../views/pages/projects/Timeline.vue";
import Pricing from "../views/pages/Pricing.vue";
import RTL from "../views/pages/Rtl.vue";
import Charts from "../views/pages/Charts.vue";
import Notifications from "../views/pages/Notifications.vue";
import Kanban from "../views/applications/Kanban.vue";
import Wizard from "../views/applications/wizard/Wizard.vue";
import DataTables from "../views/applications/DataTables.vue";
import Calendar from "../views/applications/Calendar.vue";
import NewProduct from "../views/ecommerce/products/NewProduct.vue";
import EditProduct from "../views/ecommerce/products/EditProduct.vue";
import ProductPage from "../views/ecommerce/products/ProductPage.vue";
import OrderDetails from "../views/ecommerce/orders/OrderDetails";
import OrderList from "../views/ecommerce/orders/OrderList";
import NewUser from "../views/pages/users/NewUser.vue";
import Settings from "../views/pages/account/Settings.vue";
import Billing from "../views/pages/account/Billing.vue";
import Invoice from "../views/pages/account/Invoice.vue";
import Widgets from "../views/pages/Widgets.vue";
import Basic from "../views/auth/signin/Basic.vue";
import Cover from "../views/auth/signin/Cover.vue";
import Illustration from "../views/auth/signin/Illustration.vue";
import ResetCover from "../views/auth/reset/Cover.vue";
import SignupCover from "../views/auth/signup/Cover.vue";

import UserProfiles from "../views/examples-api/user-profile/UserProfile.vue";
import RolesList from "../views/examples-api/roles/RolesList.vue";
import EditRole from "../views/examples-api/roles/EditRole.vue";
import AddRole from "../views/examples-api/roles/AddRole.vue";
import UsersList from "../views/examples-api/users/UsersList.vue";
import EditUser from "../views/examples-api/users/edit-user/EditUser.vue";
import AddUser from "../views/examples-api/users/add-user/AddUser.vue";
import TagsList from "../views/examples-api/tags/TagsList.vue";
import AddTag from "../views/examples-api/tags/AddTag.vue";
import EditTag from "../views/examples-api/tags/EditTag.vue";
import CategoriesList from "../views/examples-api/categories/CategoriesList.vue";
import AddCategory from "../views/examples-api/categories/AddCategory.vue";
import EditCategory from "../views/examples-api/categories/EditCategory.vue";
import ItemsList from "../views/examples-api/items/ItemsList.vue";
import AddItem from "../views/examples-api/items/AddItem.vue";
import EditItem from "../views/examples-api/items/EditItem.vue";

// Tolspor imports
import Login from "../views/Login.vue";
import Signup from "../views/Signup.vue";
import PasswordForgot from "../views/PasswordForgot.vue";
import PasswordReset from "../views/PasswordReset.vue";
import ConfirmRegistration from "../views/ConfirmRegistration.vue";

import MyTools from "../views/Tools/MyTools.vue";
import ToolGroup from "../views/ToolGroups/ToolGroup.vue";

// Tools
import Tools from "../views/Tools/Tools.vue";
import Tool from "../views/Tools/Tool.vue";
import ToolGeoTraces from "../views/Tools/ToolGeoTraces.vue";
import PublicTool from "../views/Tools/PublicTool.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import ToolTypes from "../views/Tools/ToolTypes.vue";

// Cars
import Cars from "../views/Cars/Cars.vue";
import Car from "../views/Cars/Car.vue";
import CarGeoTraces from "../views/Cars/CarGeoTraces.vue";
import GpsDeviceOverview from "../views/Devices/GpsDeviceOverview.vue";
// Heavy machines (Vinnuvélar)
import HeavyMachines from "../views/HeavyMachines/HeavyMachines.vue";
import HeavyMachine from "../views/HeavyMachines/HeavyMachine.vue";

// Projects
import Projects from "../views/Projects/Projects.vue";
import Project from "../views/Projects/Project.vue";
import ProjectTypes from "../views/Projects/ProjectTypes.vue";
import ProjectAssignmentTypes from "../views/Projects/ProjectAssignmentTypes.vue";
import DayProjectAssignments from "../views/Projects/DayProjectAssignments.vue";
import PreCreatedDayProjectAssignment from "../views/Projects/PreCreatedDayProjectAssignment.vue";

// Locations
import Locations from "../views/Locations/Locations.vue";

// Users
import Users from "../views/Users/Users.vue";
import UserProfile from "../views/Users/UserProfile.vue";

// Analytics
import GeneralAnalytics from "../views/Analytics/GeneralAnalytics.vue";
import WarehouseOverview from "../views/Analytics/WarehouseOverview.vue";
import CostReport from "../views/Analytics/CostReport.vue";
import TimesheetAnalytics from "../views/Analytics/TimesheetAnalytics.vue";
import LeafletMaps from "../views/Maps/LeafletMaps.vue";


// End Customers
import EndCustomers from "../views/EndCustomers/EndCustomers.vue";

// Settings
import CustomerSettings from "../views/Settings/CustomerSettings.vue";
import MasterData from "../views/Settings/MasterData.vue";
import UserSettings from "../views/Settings/UserSettings.vue";

// Time registration
import TimeRegistration from "../views/TimeRegistration/TimeRegistration.vue";

// User manual
import UserManual from "../views/Manual/UserManual.vue";

// Golf
import GolfDashboard from "../views/Golf/GolfDashboard.vue";
import GolfMap from "../views/Golf/GolfMap.vue";
import GolfHoleDetail from "../views/Golf/GreenDetail.vue";
import GolfSettings from "../views/Golf/GolfSettings.vue";
import Planner from "../views/Golf/Planner.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/dashboards/dashboard-default",
    name: "Default",
    component: Default,
  },
  {
    path: "/dashboards/sales",
    name: "Sales",
    component: Sales,
  },
  {
    path: "/pages/profile/overview",
    name: "Profile Overview",
    component: Overview,
  },
  {
    path: "/pages/profile/projects",
    name: "All Projects",
    component: Projectss,
  },
  {
    path: "/pages/projects/timeline",
    name: "Timeline",
    component: Timeline,
  },
  {
    path: "/pages/pricing-page",
    name: "Pricing Page",
    component: Pricing,
  },
  {
    path: "/pages/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/pages/charts",
    name: "Charts",
    component: Charts,
  },
  {
    path: "/pages/widgets",
    name: "Widgets",
    component: Widgets,
  },
  {
    path: "/pages/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/applications/kanban",
    name: "Kanban",
    component: Kanban,
  },
  {
    path: "/applications/wizard",
    name: "Wizard",
    component: Wizard,
  },
  {
    path: "/applications/data-tables",
    name: "Data Tables",
    component: DataTables,
  },
  {
    path: "/applications/calendar",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/ecommerce/products/new-product",
    name: "New Product",
    component: NewProduct,
  },
  {
    path: "/ecommerce/products/edit-product",
    name: "Edit Product",
    component: EditProduct,
  },
  {
    path: "/ecommerce/products/product-page",
    name: "Product Page",
    component: ProductPage,
  },
  {
    path: "/ecommerce/Orders/order-details",
    name: "Order Details",
    component: OrderDetails,
  },
  {
    path: "/ecommerce/Orders/order-list",
    name: "Order List",
    component: OrderList,
  },
  {
    path: "/pages/users/new-user",
    name: "New User",
    component: NewUser,
  },
  {
    path: "/pages/account/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/pages/account/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/pages/account/invoice",
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/authentication/signin/basic",
    name: "Signin Basic",
    component: Basic,
  },
  {
    path: "/authentication/signin/cover",
    name: "Signin Cover",
    component: Cover,
  },
  {
    path: "/authentication/signin/illustration",
    name: "Signin Illustration",
    component: Illustration,
  },
  {
    path: "/authentication/reset/cover",
    name: "Reset Cover",
    component: ResetCover,
  },
  {
    path: "/authentication/signup/cover",
    name: "Signup Cover",
    component: SignupCover,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      authRequired: false,
      permission: null
    }
  },
  // ============= TOLSPOR ROUTES =============
  {
    path: "/mytools",
    name: "Home",
    component: MyTools,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/tools",
    name: "Tools",
    component: Tools,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/tool/:toolId",
    name: "Tool",
    component: Tool,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/tool/:toolId/geotraces",
    name: "Tool GeoTraces",
    component: ToolGeoTraces,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/tooltypes",
    name: "Tool Types",
    component: ToolTypes,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/cars",
    name: "Cars",
    component: Cars,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/car/:toolGroupId",
    name: "Car",
    component: Car,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/car/:toolGroupId/geotraces",
    name: "Car GeoTraces",
    component: CarGeoTraces,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/heavymachines",
    name: "Heavy Machines",
    component: HeavyMachines,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/heavymachine/:toolGroupId",
    name: "Heavy Machine",
    component: HeavyMachine,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/heavymachine/:toolGroupId/geotraces",
    name: "Heavy Machine GeoTraces",
    component: CarGeoTraces,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/gps-devices",
    name: "GPS Devices",
    component: GpsDeviceOverview,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/projects",
    name: "Projects",
    component: Projects,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/project/:projectId",
    name: "Project",
    component: Project,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/projecttypes",
    name: "Project Types",
    component: ProjectTypes,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/projectassignmenttypes",
    name: "Project Assignment Types",
    component: ProjectAssignmentTypes,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/locations",
    name: "Locations",
    component: Locations,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/user/:userId",
    name: "User",
    component: UserProfile,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: '/userProfile',
    name: 'User Profile',
    component: UserProfile,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/userprofile/:userId",
    name: "User Profile Page",
    component: UserProfile,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/manual",
    name: "User Manual",
    component: UserManual,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/analytics/general",
    name: "General Analytics",
    component: GeneralAnalytics,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/analytics/warehouse",
    name: "Warehouse Overview",
    component: WarehouseOverview,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/analytics/costreport",
    name: "Cost Report",
    component: CostReport,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/analytics/timesheet",
    name: "Timesheet Analytics",
    component: TimesheetAnalytics,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/analytics/map",
    name: "Leaflet Maps",
    component: LeafletMaps,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/todaysAssignments",
    name: "Day Project Assignments",
    component: DayProjectAssignments,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/preCreatedTodaysAssignments",
    name: "Pre Created Day Project Assignments",
    component: PreCreatedDayProjectAssignment,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/toolgroup/:toolGroupId",
    name: "Tool Group",
    component: ToolGroup,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/time-registration",
    name: "Time Registration",
    component: TimeRegistration,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/time-registration/groups",
    name: "TimeRegistration Groups",
    component: () => import("../views/TimeRegistration/ManageGroups.vue"),
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/time-registration/clock-in-locations",
    name: "TimeRegistration ClockInLocations",
    component: () => import("../views/TimeRegistration/ManageClockInLocations.vue"),
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/golf",
    name: "Golf Dashboard",
    component: GolfDashboard,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/golf/map",
    name: "Golf Map",
    component: GolfMap,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/golf/hole/:holeId",
    name: "Golf Hole Detail",
    component: GolfHoleDetail,
    props: route => ({ holeId: Number(route.params.holeId) }),
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/golf/settings",
    name: "Golf Settings",
    component: GolfSettings,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/golf/planner",
    name: "Golf Planner",
    component: Planner,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/endcustomers",
    name: "End Customers",
    component: EndCustomers,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/settings/customersettings",
    name: "Customer Settings",
    component: CustomerSettings,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/settings/user",
    name: "User Settings",
    component: UserSettings,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/settings/masterdata",
    name: "Master Data",
    component: MasterData,
    meta: {
      authRequired: true,
      permission: ['Admin', 'SuperAdmin']
    }
  },
  {
    path: "/public/tool/:toolId",
    name: "Public Tool",
    component: PublicTool,
    meta: {
      authRequired: false,
      permission: null,
      hideLayout: true
    }
  },
  {
    path: "/privacy",
    name: "Privacy Policy",
    component: PrivacyPolicy,
    meta: {
      authRequired: false,
      permission: null,
      hideLayout: true
    }
  },
  // ============= END TOLSPOR ROUTES =============
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: {
      authRequired: false,
      permission: null
    }
  },
  {
    path: "/forgot-password",
    name: "PasswordForgot",
    component: PasswordForgot,
    meta: {
      authRequired: false,
      permission: null
    }
  },
  {
    path: "/reset-password",
    name: "PasswordReset",
    component: PasswordReset,
    meta: {
      authRequired: false,
      permission: null
    }
  },
  {
    path: "/confirm-registration",
    name: "ConfirmRegistration",
    component: ConfirmRegistration,
    meta: {
      authRequired: false,
      permission: null
    }
  },
  {
    path: "/examples/user-profile",
    name: "User Profiles",
    component: UserProfiles,
    meta: {
      authRequired: true,
      permission: null
    }
  },
  {
    path: "/examples/roles-list",
    name: "Roles List",
    component: RolesList,
    meta: {
      authRequired: true,
      permission: ['admin']
    }
  },
  {
    path: "/examples/add-role",
    name: "Add Role",
    component: AddRole,
    meta: {
      authRequired: true,
      permission: ['admin']
    }
  },
  {
    path: "/examples/edit-role",
    name: "Edit Role",
    component: EditRole,
    meta: {
      authRequired: true,
      permission: ['admin']
    }
  },
  {
    path: "/examples/users-list",
    name: "Users List",
    component: UsersList,
    meta: {
      authRequired: true,
      permission: ['admin']
    }
  },
  {
    path: "/examples/add-user",
    name: "Add User",
    component: AddUser,
    meta: {
      authRequired: true,
      permission: ['admin']
    }
  },
  {
    path: "/examples/edit-user",
    name: "Edit User",
    component: EditUser,
    meta: {
      authRequired: true,
      permission: ['admin']
    }
  },
  {
    path: "/examples/tags-list",
    name: "Tags List",
    component: TagsList,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/add-tag",
    name: "Add Tag",
    component: AddTag,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/edit-tag",
    name: "Edit Tag",
    component: EditTag,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/categories-list",
    name: "Categories List",
    component: CategoriesList,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/add-category",
    name: "Add Category",
    component: AddCategory,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/edit-category",
    name: "Edit Category",
    component: EditCategory,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/items-list",
    name: "Items List",
    component: ItemsList,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/add-item",
    name: "Add Item",
    component: AddItem,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/examples/edit-item",
    name: "Edit Item",
    component: EditItem,
    meta: {
      authRequired: true,
      permission: ['admin', 'creator']
    }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/mytools",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  }
});

//eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = await authService.checkAuth();
  const userRole = authService.getUserRole();
  if (to.matched.some(record => record.meta.authRequired) && !isAuthenticated) {
    // Redirect unauthenticated users scanning a tool QR code to the public tool page
    if (to.name === 'Tool' && to.params.toolId) {
      next({ name: 'Public Tool', params: { toolId: to.params.toolId } });
      return;
    }
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else if (to.path === '/login' && isAuthenticated) {
    const redirect = to.query.redirect || await getDefaultAppScreen();
    next({ path: redirect });
  } else if (to.matched.some(record => record.meta.permission && !record.meta.permission.includes(userRole))) {
    next({ path: '/not-authorized' });
  } else if (isAuthenticated && to.path === '/mytools' && to.redirectedFrom && to.redirectedFrom.path !== '/mytools') {
    // Landed on /mytools via a redirect (e.g. opening the app at "/") rather than
    // explicit navigation — honor the customer's configured default screen.
    const defaultScreen = await getDefaultAppScreen();
    if (defaultScreen !== '/mytools') {
      next({ path: defaultScreen });
    } else {
      next();
    }
  } else {
    next();
  }
});

// Fallback for users who never background the app: if a lazy-loaded chunk
// 404s because a new version deleted it, reload to pick up the new bundle.
router.onError((error, to) => {
  const msg = error?.message || '';
  if (/Loading chunk \S+ failed|Importing a module script failed|ChunkLoadError/i.test(msg)) {
    window.location.assign(to.fullPath);
  }
});

export default router;
